import { ExtendedFormObject, ExtendedFormState } from '../ExtendedForm';
import { useState, useMemo } from 'react';

export interface ExtendedFormHookProps<T> {
    onFormFinish?: (values: T) => void;
}

export const useExtendedForm = <T extends object>(
    props?: ExtendedFormHookProps<T>,
): [ExtendedFormState, ExtendedFormObject<T>] => {
    const [reactiveState, setReactiveState] = useState({
        isDirty: false,
        isInvalid: false,
    });

    const extendedFormObject = useMemo((): ExtendedFormObject<T> => {
        const updateState = (state: Partial<ExtendedFormState>) => {
            setReactiveState((prev) => ({
                ...prev,
                ...state,
            }));
        };

        return {
            updateState,
            onFinish: (values) => {
                props?.onFormFinish?.(values);
            },
        };
    }, [props?.onFormFinish]);

    return useMemo(() => [reactiveState, extendedFormObject] as const, [reactiveState, extendedFormObject]);
};
